if (!customElements.get("enova-qty-select")) {
  const QTY_CAP = 10;

  customElements.define(
    "enova-qty-select",
    class EnovaQtySelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector("select");
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        if (!this.select) return;

        this.select.addEventListener("click", (event) => event.stopPropagation());
        this.select.addEventListener("mousedown", (event) => event.stopPropagation());
        this.select.addEventListener("change", () => {
          document.querySelectorAll("enova-qty-select select").forEach((other) => {
            if (other === this.select) return;
            if ([...other.options].some((option) => option.value === this.select.value)) {
              other.value = this.select.value;
            }
          });
        });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (sectionId !== this.sectionId || productId !== this.productId || !this.select) return;

        const quantityFormUpdated = parsedHTML.getElementById(`QuantityForm-${sectionId}`);
        if (!quantityFormUpdated) return;

        const updated =
          quantityFormUpdated.querySelector(".enova-atc__qty") ||
          quantityFormUpdated.querySelector(".m-quantity__input");
        if (!updated) return;

        ["data-cart-quantity", "data-min", "data-max", "step"].forEach((attribute) => {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            this.select.setAttribute(attribute, valueUpdated);
          } else {
            this.select.removeAttribute(attribute);
          }
        });
      }

      setQuantityBoundries(sectionId, productId) {
        if (sectionId !== this.sectionId || productId !== this.productId || !this.select) return;

        const cartQuantity = this.select.hasAttribute("data-cart-quantity")
          ? parseInt(this.select.getAttribute("data-cart-quantity"), 10)
          : 0;
        const minAttr = this.select.getAttribute("data-min");
        const maxAttr = this.select.getAttribute("data-max");
        const stepAttr = this.select.getAttribute("step");

        let min = minAttr ? parseInt(minAttr, 10) : 1;
        let step = stepAttr ? parseInt(stepAttr, 10) : 1;
        if (!Number.isFinite(min) || min < 1) min = 1;
        if (!Number.isFinite(step) || step < 1) step = 1;

        let max = maxAttr ? parseInt(maxAttr, 10) - cartQuantity : QTY_CAP;
        if (!Number.isFinite(max)) max = QTY_CAP;
        max = Math.min(Math.max(max, min), QTY_CAP);

        const previous = parseInt(this.select.value, 10);
        this.select.innerHTML = "";
        for (let qty = min; qty <= max; qty += step) {
          const option = document.createElement("option");
          option.value = String(qty);
          option.textContent = String(qty);
          this.select.appendChild(option);
        }

        const values = [...this.select.options].map((option) => parseInt(option.value, 10));
        this.select.value = values.includes(previous) ? String(previous) : String(min);
      }
    }
  );
}
